import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';

import services from '../../services';

import './styles.scss';

import logoCompany from '../../assets/img/logo.png';
import iconCadastro from '../../assets/icons/icon-cadastro.svg';
import iconHome from '../../assets/icons/icon-home.svg';
import iconBusiness from '../../assets/icons/icon-business.svg';
import iconOportunidade from '../../assets/icons/icon-oportunidade.svg';
import iconNegociacao from '../../assets/icons/icon-negociacao.svg';
import iconGestao from '../../assets/icons/icon-gestao.svg';
import iconConfiguracoes from '../../assets/icons/icon-configuracoes.svg';
import { Icon } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
    imageIcon: {
        height: '100%'
    },
    iconRoot: {
        textAlign: 'center',
        fontWeight: 'normal'
    }
});

const SidebarMenu = () => {
    const history = useHistory();

    const [showSubMenu, setShowSubMenu] = React.useState('');
    const [showMobileMenu, setShowMobileMenu] = React.useState('');
    const [selected, setSelected] = React.useState('');
    const [idSeller, setIdSeller] = React.useState('');

    useEffect(() => {
        verificarAcessoSeller();
    }, [])

    const verificarAcessoSeller = () => {
        const { idSeller } = services.storage.getUser();

        setIdSeller(idSeller);
    }

    const openSubMenu = (menuItem) => {
        handleClassSelected(menuItem);
        if (showSubMenu === menuItem) {
            setShowSubMenu('');
        } else {
            setShowSubMenu(menuItem);
        }
    }

    const topMenuToggle = () => {
        setShowMobileMenu(!showMobileMenu)
    }

    const handleClassSelected = (menuItem) => {
        console.log(menuItem);
        if (selected === menuItem) {
            setSelected('');
        } else {
            setSelected(menuItem);
        }
    }

    const showSubMenuCadastros = () => {
        if (!idSeller) {
            return (
                <div className="menu-sub-menu">
                    <Link to='/admin/administradores' className="list-group-item sub">
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-7 txt">Administradores</div>
                            <div className="col-3"></div>
                        </div>
                    </Link>
                    <Link to='/admin/sellers' className="list-group-item sub">
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-7 txt">Seller</div>
                            <div className="col-3"></div>
                        </div>
                    </Link>
                    <Link to='/admin/buyers' className="list-group-item sub">
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-7 txt">Buyer</div>
                            <div className="col-3"></div>
                        </div>
                    </Link>
                    <Link to='/produto' className="list-group-item sub">
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-7 txt">Produtos</div>
                            <div className="col-3"></div>
                        </div>
                    </Link>
                    <Link to='/configuracoes' className="list-group-item sub">
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-9 txt">Configurações</div>
                            <div className="col-3"></div>
                        </div>
                    </Link>
                </div>
            )
        } else {
            return (
                <div className="menu-sub-menu">
                    <Link to='/seller/empresa' className="list-group-item sub">
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-7 txt">Empresa</div>
                            <div className="col-3"></div>
                        </div>
                    </Link>
                    <Link to='/seller/filial-cd' className="list-group-item sub">
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-7 txt">Filiais / CDs</div>
                            <div className="col-3"></div>
                        </div>
                    </Link>
                   {/*  <Link to='/seller/filial' className="list-group-item sub">
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-7 txt">Filiais</div>
                            <div className="col-3"></div>
                        </div>
                    </Link> */}
                    <Link to='/produto' className="list-group-item sub">
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-7 txt">Produtos</div>
                            <div className="col-3"></div>
                        </div>
                    </Link>
                    <Link to='/seller/usuario' className="list-group-item sub">
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-7 txt">Usuários</div>
                            <div className="col-3"></div>
                        </div>
                    </Link>
                    <Link to='/seller/remuneracao' className="list-group-item sub">
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-7 txt">Contrato Greeners</div>
                            <div className="col-3"></div>
                        </div>
                    </Link>
                </div>
            )
        }
    }

    const showSubMenuOportunidades = () => {
        if (!idSeller) {
            return (
                <div className="menu-sub-menu">
                    <Link to={!idSeller ? '/oportunidade/importacao' : '/seller/oportunidade/importacao'} className="list-group-item sub">
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-9 txt">Importação</div>
                            <div className="col-3"></div>
                        </div>
                    </Link>
                    <Link to={!idSeller ? '/oportunidade' : '/seller/oportunidade'} className="list-group-item sub">
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-9 txt">Histórico de Oportunidades</div>
                            <div className="col-3"></div>
                        </div>
                    </Link>
                    <Link to={!idSeller ? '/gestaoPedidos' : '/seller/gestaoPedidos'} className="list-group-item sub">
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-9 txt">Gestão de Pedidos</div>
                            <div className="col-3"></div>
                        </div>
                    </Link>
                </div>
            )
        }
    }

    const showSubMenuConfiguracoes = () => {
        return (
            <div className="menu-sub-menu">
                <Link to='/configuracoes/motivo-oferta' className="list-group-item sub">
                    <div className="row">
                        <div className="col-2"></div>
                        <div className="col-7 txt">Motivo da Oferta</div>
                        <div className="col-3"></div>
                    </div>
                </Link>
                <Link to='/configuracoes/status-oferta' className="list-group-item sub">
                    <div className="row">
                        <div className="col-2"></div>
                        <div className="col-7 txt">Status da Oferta</div>
                        <div className="col-3"></div>
                    </div>
                </Link>
            </div>
        )
    }

    const sair = () => {
        services.storage.clear()
        history.push(`/`)
    }

    return (
        <div className='sideBarMenuContainer'>
            <div className="lineTop"></div>
            <div className="mainHeader">
                <Link to='/home'>
                    <img src={logoCompany} alt="recrutae" className="logoCompany" />
                </Link>

                <div className="navbarMenu">
                    <button type="button" className="navbar-toggle" onClick={() => topMenuToggle()}>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                    </button>
                </div>
            </div>

            <div className={`mainMenuSidebar ${showMobileMenu ? '' : 'hideMenu'}`} >
                <Link to='/Home' className={`list-group-item ${selected === 'home' ? 'menu-selected' : ''}`}>
                    <div
                        onClick={() => handleClassSelected('home')}
                    >
                        <div className="menu-opcao row">
                            <div className="col-2 left">
                                <Icon classes={{ root: useStyles.iconRoot }} className='icon'>
                                    <img src={iconHome} />
                                </Icon>
                            </div>
                            <div className="txt col-7 font">Home</div>
                            <div className="col-3"></div>
                        </div>
                    </div>
                </Link>
                <div
                    className={`list-group-item ${selected === 'cadastros' ? 'menu-selected' : ''}`}
                    onClick={() => openSubMenu('cadastros')}>
                    <div
                        onClick={() => openSubMenu('cadastros')}
                    >
                        <div className="menu-opcao row">
                            <div className="col-2 left">
                                <Icon classes={{ root: useStyles.iconRoot }}>
                                    <img src={iconCadastro} />
                                </Icon>
                            </div>
                            <div className="col-7 txt">Cadastros</div>
                            <div className="col-3"></div>
                        </div>
                    </div>
                </div>
                {showSubMenu === 'cadastros' &&
                    (showSubMenuCadastros())
                }
                <div
                    className={`list-group-item ${selected === 'oportunidade' ? 'menu-selected' : ''}`}
                    onClick={() => openSubMenu('oportunidade')}>
                    <div
                        onClick={() => openSubMenu('oportunidade')}
                    >
                        <div className="row">
                            <div className="col-2 left">
                                <Icon classes={{ root: useStyles.iconRoot }}>
                                    <img src={iconOportunidade} />
                                </Icon>
                            </div>
                            <div className="col-7 txt">Oportunidades</div>
                            <div className="col-3"></div>
                        </div>
                    </div>
                </div>
                {showSubMenu === 'oportunidade' &&
                    (showSubMenuOportunidades())
                }
                {/* <div
                    className={`list-group-item ${selected === 'configuracoes' ? 'menu-selected' : ''}`}
                    onClick={() => openSubMenu('configuracoes')}>
                    <div
                        onClick={() => openSubMenu('configuracoes')}
                    >
                        <div className="row">
                            <div className="col-2 left">
                                <Icon classes={{ root: useStyles.iconRoot }}>
                                    <img src={iconConfiguracoes} />
                                </Icon>
                            </div>
                            <div className="col-7 txt">Configurações</div>
                            <div className="col-3"></div>
                        </div>
                    </div>
                </div> */}
                {showSubMenu === 'configuracoes' &&
                    (showSubMenuConfiguracoes())
                }
                {/* <Link to={!idSeller ? '/oportunidade' : '/seller/oportunidade'} className={`list-group-item ${selected === 'oportunidade' ? 'menu-selected' : ''}`}>
                    <div
                        onClick={() => handleClassSelected('oportunidade')}
                    >
                        <div className="row">
                            <div className="col-2 left">
                                <Icon classes={{ root: useStyles.iconRoot }}>
                                    <img src={iconOportunidade} />
                                </Icon>
                            </div>
                            <div className="col-7 txt">Oportunidades</div>
                            <div className="col-3"></div>
                        </div>
                    </div>
                </Link> */}
                {/*  Segunda fase */}
                
                {/* <Link to='/home' className={`list-group-item ${selected === 'negociacao' ? 'menu-selected' : ''}`}>
                    <div
                        onClick={() => handleClassSelected('negociacao')}
                    >
                        <div className="menu-opcao row">
                        <div className="col-2 left">
                                <Icon classes={{ root: useStyles.iconRoot}}>
                                    <img src={iconNegociacao} />
                                </Icon>
                            </div>
                            <div className="col-7 txt">Negociações</div>
                            <div className="col-3"></div>
                        </div>
                    </div>
                </Link>
                <div 
                    className={`list-group-item ${selected === 'financeira' ? 'menu-selected' : ''}`} 
                    onClick={() => openSubMenu('financeira')}>
                    <div 
                        onClick={() => handleClassSelected('financeira')}    
                    >
                        <div className="menu-opcao row">
                        <div className="col-2 left">
                                <Icon classes={{ root: useStyles.iconRoot}}>
                                    <img src={iconGestao} />
                                </Icon>
                            </div>
                            <div className="col-7 txt">Gestão Financeira</div>
                            <div className="col-3"></div>
                        </div>
                    </div>
                </div>
                { showSubMenu === 'financeira' &&
                    <div className="menu-sub-menu">
                        <Link to='/home' className="list-group-item sub">
                            <div className="row">
                                <div className="col-2"></div>
                                <div className="col-7 txt">Pedidos de Compra</div>
                                <div className="col-3"></div>
                            </div>
                        </Link>
                        <Link to='/home' className="list-group-item sub">
                            <div className="row">
                                <div className="col-2"></div>
                                <div className="col-9 txt">Ordens de Pagamento</div>
                                <div className="col-1"></div>
                            </div>
                        </Link>
                        <Link to='/home' className="list-group-item sub">
                            <div className="row">
                                <div className="col-2"></div>
                                <div className="col-7 txt">Fechamento</div>
                                <div className="col-3"></div>
                            </div>
                        </Link>
                    </div>
                }
                <Link to='/home' className={`list-group-item ${selected === 'business' ? 'menu-selected' : ''}`}>
                    <div
                        onClick={() => handleClassSelected('business')}
                    >
                        <div className="menu-opcao row">
                        <div className="col-2 left">
                                <Icon classes={{ root: useStyles.iconRoot}}>
                                    <img src={iconBusiness} />
                                </Icon>
                            </div>
                            <div className="col-9 txt">Business Intelligence</div>
                            <div className="col-1"></div>
                        </div>
                    </div>
                </Link> */}

            </div>

        </div>
    )
}

export default SidebarMenu;